import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HizmetlerPage from "../pages/hizmetler/page";
import HakkimizdaPage from "../pages/hakkimizda/page";
import ReferanslarPage from "../pages/referanslar/page";
import IletisimPage from "../pages/iletisim/page";
import SSSPage from "../pages/sss/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hizmetler", element: <HizmetlerPage /> },
  { path: "/hakkimizda", element: <HakkimizdaPage /> },
  { path: "/referanslar", element: <ReferanslarPage /> },
  { path: "/iletisim", element: <IletisimPage /> },
  { path: "/sss", element: <SSSPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
